import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Handles scroll-to-top on route and search parameter changes (like pagination)
 * while preserving scroll position on back/forward (POP) navigation
 */
function SmoothScroll({ children }: { children: React.ReactNode }) {
  const { pathname, search } = useLocation();
  const navType = useNavigationType();

  // Scroll to top on route/search changes (but preserve position on POP/back navigation)
  useEffect(() => {
    // Disable automatic scroll restoration by the browser
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    console.log('[SmoothScroll] Route changed:', { pathname, search, navType });
    if (navType !== 'POP') {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      // Also handles layout scrolling containers if applicable
      const scrollContainers = document.querySelectorAll('.overflow-auto, .overflow-y-auto');
      scrollContainers.forEach(container => {
        container.scrollTop = 0;
      });
    }
  }, [pathname, search, navType]);

  // Handle initial load
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return <>{children}</>;
}

export default SmoothScroll;
